import {
  Home,
} from 'ui/home';

import {
  lazyRoute,
} from 'common/components';

import {
  lazyLoadComponent,
} from 'common/utils';

const SummerFestival = lazyLoadComponent('SummerFestival');
const SummerFestivalEvents = lazyLoadComponent('SummerFestivalEvents');

export const HomeRoutes = {
  home: {
    component: Home,
    path: '/home',
    default: true,
  },
  summerFestival: {
    component: lazyRoute(SummerFestival),
    path: '/summerfestival',
  },
  summerFestivalEvents: {
    component: lazyRoute(SummerFestivalEvents),
    path: '/summerfestival/:festival',
  },
};
